async function updateByobProgressContent() {
    const res = await fetch("https://lawlessbeauty.com/pages/build-your-own-bundle?setions=shopify-section-template--16659881164877__byob_rVRkkj");
    const data = await res.text();
    const html = new DOMParser().parseFromString(data, 'text/html');
    const contentUpdateDiscounts = html.querySelector('.byob-content-progress-bar');
    const sectionContainer = document.querySelector('.byob-content-progress-bar');

    sectionContainer.innerHTML = contentUpdateDiscounts.innerHTML;
}

document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => window.liquidAjaxCart.subscribeToCartSectionsUpdate(updateByobProgressContent), 3000)
});